import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult({ status }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const provider = params.get("provider") || "stripe";
  const sessionId = params.get("session_id");
  const groupId = params.get("group_id");
  const [state, setState] = useState({ loading: status === "success", text: status === "success" ? "Confirming your payment..." : "Payment cancelled" });

  useEffect(() => {
    if (status !== "success" || provider !== "stripe" || !sessionId) return;
    let attempts = 0; let stop = false;
    const poll = async () => {
      if (stop || attempts >= 8) {
        setState({ loading: false, text: "Payment status not confirmed yet. Check your email or dashboard." });
        return;
      }
      attempts += 1;
      try {
        const r = await api.get(`/payments/stripe/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setState({ loading: false, text: "Payment successful!" });
          setTimeout(() => navigate(`/booking-confirmation/${groupId}`), 800);
          return;
        }
        if (r.data.status === "expired") {
          setState({ loading: false, text: "Payment session expired." });
          return;
        }
      } catch (e) { /* ignore */ }
      setTimeout(poll, 1500);
    };
    poll();
    return () => { stop = true; };
  }, [status, provider, sessionId, groupId, navigate]);

  const ok = status === "success";
  return (
    <div className="mx-auto max-w-md px-4 py-16 text-center" data-testid="payment-result-page">
      <div className="rounded-3xl bg-card border border-border p-8">
        {state.loading ? <Loader2 className="h-10 w-10 mx-auto animate-spin text-[hsl(var(--primary))]" /> : ok ? <CheckCircle className="h-10 w-10 mx-auto text-emerald-600" /> : <XCircle className="h-10 w-10 mx-auto text-rose-500" />}
        <h1 className="font-display text-2xl font-semibold mt-3">{state.text}</h1>
        {!state.loading && (
          <div className="mt-4 flex flex-col gap-2">
            {ok ? <Button onClick={() => navigate(`/booking-confirmation/${groupId}`)} className="rounded-xl" data-testid="go-to-confirmation">View booking</Button> : null}
            <Link to="/dashboard"><Button variant="ghost" className="rounded-xl w-full">Go to my trips</Button></Link>
          </div>
        )}
      </div>
    </div>
  );
}
